import React from 'react';
import PropTypes from 'prop-types';

const GalleryLogo = () => {
  const galleryLogo = 
	 <picture>
	  <source srcset="https://www.purewow.com/static-gmg/gmg-site/images/logos/gallery-media-group-logo-gray.svg"/> 
	  <img className="gallery-logo-img" src="https://www.purewow.com/static-gmg/gmg-site/images/logos/gallery-media-group-logo-gray.webp" alt="Gallery Media Group logo"/>
	</picture>;

  return (
    <a className='gallery-logo' href='https://www.gallerymediagroup.com/'>
      	{galleryLogo}
    </a>
  );
};

GalleryLogo.propTypes = {
  className: PropTypes.string,
};

export default GalleryLogo;
